/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */

import { ComponentType, lazy } from 'react';

// This is an approach taken from https://medium.com/@alonmiz1234/retry-dynamic-imports-with-react-lazy-c7755a7d557a
export const lazyWithRetries = (url: string) => {
  // This function will be called with a lazy importer function
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const retryImport = async (): Promise<{ default: ComponentType<any> }> => {
    const maxRetries = 5;
    const backoffDelay = 2; // seconds

    try {
      const module = await import(/* webpackIgnore: true */ url); // Assuming shimport returns { default: T }
      return module;
    } catch (error: any) {
      // Retry logic with exponential backoff
      for (let i = 0; i < maxRetries; i++) {
        await new Promise<void>(
          (resolve) => {
            setTimeout(resolve, 1000 * backoffDelay ** i);
          } // Exponential backoff
        );
        const retryUrl = new URL(url);
        retryUrl.searchParams.set('t', `${+new Date()}`); // Cache-busting by adding timestamp

        try {
          const module = await import(/* webpackIgnore: true */ retryUrl.href); // Retry import using the cache-busted URL
          return module;
        } catch (retryError) {
          console.log('Caught retry error', retryError);
        }
      }

      // If all retries fail, throw the original error
      throw error;
    }
  };

  // The function returns the lazy component after applying retry logic
  return lazy(retryImport);
};
/**
 * polyfill for import()
 * @param {string} url - the url of the file to import
 */
// @ts-expect-error shimport not on window
export default window.__shimport__.load;
